import { makeToggleCard } from '../Checkable/ToggleCard'

export default makeToggleCard({ type: 'checkbox', displayName: 'CheckBoxCard' })
